var map = {
	"./16px/add.svg": 59318,
	"./16px/arrow-down.svg": 41229,
	"./16px/circle-divider.svg": 41817,
	"./16px/clock-grey.svg": 78359,
	"./16px/clock.svg": 52537,
	"./16px/close-circle-inverted.svg": 62942,
	"./16px/close.svg": 1151,
	"./16px/columns.svg": 62486,
	"./16px/delete-full.svg": 90122,
	"./16px/delete.svg": 34652,
	"./16px/down.svg": 81801,
	"./16px/download.svg": 49929,
	"./16px/edit-icon.svg": 13157,
	"./16px/edit.svg": 18577,
	"./16px/help-circle.svg": 16185,
	"./16px/left.svg": 92562,
	"./16px/link.svg": 85713,
	"./16px/new-window.svg": 15430,
	"./16px/padlock.svg": 60613,
	"./16px/plus.svg": 9857,
	"./16px/reset.svg": 95786,
	"./16px/right.svg": 32649,
	"./16px/search.svg": 65629,
	"./16px/swap-vertical.svg": 42635,
	"./16px/tick.svg": 7498,
	"./16px/up.svg": 21126,
	"./16px/venue.svg": 16822,
	"./16px/warning.svg": 11923,
	"./24px/add-circle-full.svg": 89660,
	"./24px/add-circle.svg": 29222,
	"./24px/add.svg": 87753,
	"./24px/alarm.svg": 46751,
	"./24px/alert-circle.svg": 35135,
	"./24px/alert-triangle.svg": 47843,
	"./24px/alert.svg": 35570,
	"./24px/annotation.svg": 82663,
	"./24px/arrow-down-grey.svg": 83552,
	"./24px/calendar.svg": 46890,
	"./24px/clock-end.svg": 6522,
	"./24px/clock.svg": 10890,
	"./24px/close-circle.svg": 72601,
	"./24px/close.svg": 29996,
	"./24px/delete-red.svg": 99299,
	"./24px/delete.svg": 62017,
	"./24px/dollar-circ.svg": 10102,
	"./24px/dollar-circle.svg": 35775,
	"./24px/dollar.svg": 93074,
	"./24px/double-arrow.svg": 39339,
	"./24px/down-arrow.svg": 20672,
	"./24px/download.svg": 52360,
	"./24px/fullscreen.svg": 16403,
	"./24px/handcursor.svg": 28097,
	"./24px/help-circle.svg": 29062,
	"./24px/hourglass.svg": 86934,
	"./24px/invite-link.svg": 5028,
	"./24px/launch.svg": 28857,
	"./24px/link.svg": 9576,
	"./24px/mail.svg": 29117,
	"./24px/minus-glyph.svg": 29477,
	"./24px/mixed-chart.svg": 65926,
	"./24px/more-options.svg": 36398,
	"./24px/new-window.svg": 67707,
	"./24px/penalty.svg": 97511,
	"./24px/pound-circle.svg": 46979,
	"./24px/pound.svg": 80934,
	"./24px/remove-circle.svg": 78605,
	"./24px/settings.svg": 19199,
	"./24px/swap-vertical.svg": 89864,
	"./24px/tick-circle.svg": 78412,
	"./24px/tick.svg": 4047,
	"./24px/tooltip-annotation.svg": 50209,
	"./24px/users.svg": 11480,
	"./48px/check-success.svg": 71708,
	"./48px/clock.svg": 63168,
	"./48px/empty-state.svg": 91661,
	"./72px/alert.svg": 55491,
	"./72px/checklists.svg": 10532,
	"./72px/document.svg": 30276,
	"./72px/payment.svg": 19451,
	"./72px/photo.svg": 1041,
	"./72px/rankings.svg": 23858,
	"./72px/staff.svg": 60635,
	"./72px/team.svg": 76028,
	"./72px/tournament.svg": 58526,
	"./72px/user.svg": 81534,
	"./nav/areas.svg": 67229,
	"./nav/coaches.svg": 51589,
	"./nav/dashboard.svg": 18559,
	"./nav/discounts.svg": 13063,
	"./nav/events.svg": 1162,
	"./nav/facilities.svg": 88618,
	"./nav/leagues.svg": 22825,
	"./nav/membership.svg": 73073,
	"./nav/organisations.svg": 32122,
	"./nav/players.svg": 55481,
	"./nav/programming.svg": 87864,
	"./nav/ranking.svg": 17517,
	"./nav/rankings-nav.svg": 51716,
	"./nav/reports.svg": 84670,
	"./nav/schools.svg": 99028,
	"./nav/tourn.svg": 94439,
	"./nav/users.svg": 70763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95798;